import { Component, OnInit} from '@angular/core';
import { ReunionesService} from '../_services/reuniones.service';
import { MatDialog } from '@angular/material/dialog';
import { ReunionesBusquedaComponent} from '../reuniones-busqueda/reuniones-busqueda.component';

@Component({
  selector: 'reuniones-lista-barra',
  standalone: false,
  templateUrl: './reuniones-lista-barra.component.html'
})

export class ReunionesListaBarraComponent implements OnInit {

  filtersState = true;
  searchState = false;

  constructor(public dialog: MatDialog,
              private reunionesService: ReunionesService) {
  }

  ngOnInit() {
  }

  openSearch() {
    const dialogInstance = this.dialog.openDialogs.find(currDialog => currDialog.componentInstance instanceof ReunionesBusquedaComponent);
    if (dialogInstance) {
      this.reunionesService.closeSearch();
      this.searchState = false;
      return false;
    }
    this.searchState = true;
    this.reunionesService.openSearch();
    this.closeSearchSub();
  }

  closeSearchSub() {
    const dialogInstance = this.dialog.openDialogs.find(currDialog => currDialog.componentInstance instanceof ReunionesBusquedaComponent);

    dialogInstance.afterClosed().subscribe(() => {
      this.searchState = false;
    });
  }

  toggleFilters() {
    this.filtersState = !this.filtersState;
    this.reunionesService.toggleFilters(this.filtersState);
  }
}
